/**
 * ajax请求配置
 */

/**
默认application/x-www-form-urlencoded方式。
this.$axios.post("/workbench/list.admin",{
	page:1,
	count:20
}).then(res=>{})

application/json; charset=utf-8 方式,url后加 ".json" 示例如下：
this.$axios.post("/workbench/list.admin.json",{
	page:1,
	count:20
}).then(res=>{})

需要返回整个response的url后加 ".all" 示例如下
this.$axios.post("/workbench/list.admin.all",{
	page:1,
	count:20
}).then(res=>{})

all和json都需要 url:/workbench/list.admin.all.json或者/workbench/list.admin.json.all

 */
import dingtalkLoginFree from './loginFree.js'
import axios from 'axios'
const rootUrl = '/pc'
const axiosAjax={};
import Qs from 'qs'
axiosAjax.install=(Vue,option)=>{
	const $this=Vue.prototype;
	$this.$qs=Qs;
	// axios默认配置
	axios.defaults.timeout = 60000; // 超时时间
	axios.defaults.baseURL = rootUrl;  // 默认地址
	axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
	axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';
	// axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';
	//整理数据
	axios.defaults.transformRequest = function (data) {
		// data = Qs.stringify(data);
		// data = JSON.stringify(data);
		return data;
	};

	// 路由请求拦截
	// http request 拦截器
	axios.interceptors.request.use(config => {
		// 规定url后缀带有.json，认为走application/json的方式
		if(config.url&&config.url.indexOf(".json")>-1){
			config.url=config.url.split(".json").join("");
			config.headers[config.method]["Content-Type"]="application/json; charset=utf-8";
		}

		if (localStorage.qzgToken) {
			config.headers[config.method]["QZGToken"] = localStorage.qzgToken;
		}
		// 脱敏功能
		if(config.url&&config.url.indexOf(".dst")>-1){
			config.url=config.url.split(".dst").join("");
			config.headers["is-desensitization"]= 'false';
		}
		// 规定url后缀带有.all，返回全部response，否则返回response.data
		if(config.url&&config.url.indexOf(".all")>-1){
			config.url=config.url.split(".all")[0];
			config.options={
				...(config.options||{}),
				...({
					responseAll:true
				})
			}
		}
		// 规定url后缀带有.origin，认为返回所有response
		if(config.url&&config.url.indexOf(".origin")>-1){
			config.url=config.url.split(".origin").join("");
			config.options={
				...(config.options||{}),
				...({
					backOriginData:true
				})
			}
		}
		let ContentType=config.headers['Content-Type']||config.headers[config.method]["Content-Type"]
		if (ContentType=="application/x-www-form-urlencoded"){
			config.data=$this.$qs.stringify(config.data);
		}else if(ContentType=="application/json; charset=utf-8"){
			config.data=JSON.stringify(config.data);
		}
		$this.$Loading.start();
		return config;
	},
	error => {
		return Promise.reject(error.response);
	});

	// 路由响应拦截
	// http response 拦截器
	axios.interceptors.response.use(res => {
		$this.$Loading.finish();
		// 返回原始数据
		if(res.config&&res.config.options&&res.config.options.backOriginData){
			return res;
		}
		if(res.status===200){
			/*通过后台配置三方配置接口拦截，显示信息后，返回首页*/	
			if(res.data&&res.data.code===11000118){
				$this.$Modal.warning({
					title: '提示',
					content: res.data.msg||'',
					onOk: () => {
						// window.location.href=location.origin+location.pathname
						window.location.href=location.origin
					}
				});
				return Promise.reject(res.data.msg)
				/*正常情况下，或者需要返回全部数据时*/
			}else if(res.data&&((res.config.options&&res.config.options.responseAll)||res.data.code===10000000||res.data.code===10000007)){
				return (res.config.options&&res.config.options.responseAll)?res.data:res.data.data;
			/*未登陆时统一处理*/
			}else if(res.data&&res.data.code===10000012){
				//是否钉钉
				if(navigator.userAgent.includes("DingTalk")){
					dingtalkLoginFree($this)
				} else {
					if(location.href&&location.href.indexOf('/common.html#/login')==-1){
						window.location = location.origin +'/common.html#/login?bankUrl='+encodeURIComponent(location.href);
					}
					return Promise.reject(res.data.msg) // 返回接口返回的错误信息
				}
			/*其他情况下统一提示错误信息*/
			}else{
				$this.$Notice.error({
                    title: '系统提示',
                    desc: res.data.msg
				});
				return Promise.reject(res.data.msg) // 返回接口返回的错误信息
			}
		}else{
			$this.$Notice.error({
				title: '系统提示',
				desc: '系统繁忙'
			});
			$this.$Loading.error();
		}	

		// return response;
	},error => {
		$this.$Loading.error();
		return Promise.reject(error.response) // 返回接口返回的错误信息
	});

	// 将get方法改成同post方法一样的传参方式
	let axiosGet=axios.get
	axios.get=(url,params,config)=>{
		if(params&&params.params){
			params=params.params;
		}
		config={
			...(config||{}),
			params:params||{}
		}
		return axiosGet(url,config);
	}
	Vue.prototype.$axios=axios;
}

export default axiosAjax;


// WEBPACK FOOTER //
// ./src/common/axios.js